import React from 'react';

const QuickSearchLinkItem = ({ name, url }) => {
  return (
    <a
      className="underlined-link w-fit self-start py-1 font-garamond text-lg text-gray-500 lg:text-xl"
      href={url}
    >
      {name}
    </a>
  );
};

export default QuickSearchLinkItem;
